import React, { useEffect, useState } from "react";
import { HiPlus } from "react-icons/hi";
import { Button, Container } from "reactstrap";
import NoInternetComp from "../../InternetConnetction/NoInternetComp";
import AddBlogModal from "../Modal/Blog/AddBlogModal";
import { MdOutlineDelete, MdOutlineEdit } from "react-icons/md";
import toast from "react-hot-toast";
import {
  getServices,
  postServices,
  removeServices,
  updateServices,
} from "../../../../apiServices/apiServices";
import config from "../../../../config.json";
import moment from "moment";

function ManageBlogView() {
  const [modal, setModal] = useState({
    addModal: false,
    editModal: false,
  });
  const [selectedImages, setSelectedImages] = useState(null);
  const [videoUrl, setVideoUrl] = useState("");
  const [videoId, setVideoId] = useState(null);
  const [fieldData, setFieldData] = useState({
    title: "",
    description: "",
    update: false,
    // selectedImages: selectedImages,
  });
  const [previewUrl, setPreviewUrl] = useState(null);
  const [insightsData, setInsightsData] = useState([]);
  const access_token = sessionStorage.getItem("access-token");
  const baseurl = config.url;

  useEffect(() => {
    fetchInsightsList();

    if (!selectedImages) {
      setPreviewUrl(null);
      return;
    }

    const objectUrl = URL.createObjectURL(selectedImages);
    setPreviewUrl(objectUrl);

    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedImages]);

  const fetchInsightsList = async () => {
    try {
      const res = await getServices(`/api/blog/list`, access_token);

      if (res.responseCode === 200) {
        setInsightsData(res.responseData);
      } else {
        setInsightsData([]);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleAddModal = () => {
    setModal({ ...modal, addModal: true });
    setSelectedImages(null);
    setFieldData({ title: "", description: "", update: false });
    setPreviewUrl(null);
    setVideoUrl("");
    setVideoId(null);
  };

  const handleUpdateModal = (blog) => {
    setModal({ ...modal, editModal: true });
    setFieldData({
      title: blog.title,
      description: blog.description,
      blog_id: blog.blog_id,
      update: true,
    });
    setPreviewUrl(baseurl + blog.image);
    setVideoUrl(blog.youtube_url);

    const extractedId = extractYouTubeId(blog.youtube_url || "");
    setVideoId(extractedId);
  };

  const handleFileSelect = (e) => {
    // const files = Array.from(event.target.files);
    // handleImageUpload(files);
    // setFieldData({ ...fieldData, selectedImages: files[0] });
    const selectedFile = e.target.files && e.target.files[0];
    if (!selectedFile) return;

    if (!selectedFile.type.startsWith("image/")) {
      alert("Please select an image file");
      return;
    }

    setSelectedImages(selectedFile);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!fieldData.description) {
      alert("Please add a description");
    } else if (!selectedImages && modal.addModal) {
      alert("Please select an image file");
    } else {
      const formData = new FormData();

      formData.append("title", fieldData.title);
      formData.append("description", fieldData.description);
      formData.append("image", selectedImages);
      formData.append("youtube_url", videoUrl);

      try {
        if (!fieldData.update) {
          const res = await postServices(
            `/api/blog/create`,
            access_token,
            formData
          );

          if (res.responseCode === 200) {
            setModal({ ...modal, addModal: false });
            setFieldData({
              ...fieldData,
              title: "",
              description: "",
              update: false,
            });
            setSelectedImages(null);
            setVideoUrl("");
            setVideoId(null);
            fetchInsightsList();
          } else {
            toast.error(res.responseMessage);
          }
        } else {
          const res = await updateServices(
            `/api/blog/update?blog_id=${fieldData.blog_id}`,
            access_token,
            formData
          );

          if (res.responseCode === 200) {
            toast.success(
              `Insight ${fieldData.update ? "updated..." : "added..."}`
            );

            setModal({ ...modal, editModal: false });
            fetchInsightsList();
          } else {
            toast.error(res.responseMessage);
          }
        }
      } catch (error) {
        toast.error(error);
      }
    }
  };

  const handleDelete = async (blog) => {
    if (window.confirm("Are you sure you want to delete this blog?")) {
      // Delete logic here
      try {
        const res = await removeServices(
          `/api/blog/delete?blog_id=${blog.blog_id}`,
          access_token
        );

        if (res.responseCode === 200) {
          fetchInsightsList();
        } else {
          toast.error(res.responseMessage || "Something went wrong");
        }
      } catch (error) {
        toast.error(error);
      }
    }
  };

  const extractYouTubeId = (url) => {
    const patterns = [
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
      /(?:youtube\.com\/shorts\/)([^&\n?#]+)/,
      /(?:youtube\.com\/v\/)([^&\n?#]+)/,
    ];

    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match && match[1]) {
        return match[1];
      }
    }
    return null;
  };

  const handleUrlChange = (e) => {
    const url = e.target.value;
    setVideoUrl(url);
    // setError("");

    if (!url) {
      setVideoId(null);
      return;
    }

    const extractedId = extractYouTubeId(url);

    if (extractedId) {
      setVideoId(extractedId);
    } else if (url.length > 10) {
      // setError("Please enter a valid YouTube URL");
      setVideoId(null);
    }
  };

  // Get thumbnail for preview
  const getThumbnailUrl = (id) => {
    return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
  };

  return (
    <>
      {navigator.onLine ? (
        <Container>
          <Container className="flex justify-between items-center mx-0 p-4 sm:p-8">
            <p className="text-xl sm:text-2xl font-semibold">Manage Insights</p>
            <Button
              onClick={() => handleAddModal()}
              className="bg-slate-800 flex items-center px-2 sm:px-7 py-2 text-white font-semibold rounded-xl outline-none border-none active:scale-[.98] active:duration-75 transition-all hover:scale-[1.01] ease-in-out"
            >
              <HiPlus className="mr-2" /> Add Insight
            </Button>
          </Container>

          {insightsData.length > 0 ? (
            <Container className="mx-4 sm:mx-8 gap-6 mb-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
              {insightsData.map((blog, index) => (
                <Container
                  key={index}
                  className="shadow-lg rounded-2xl p-4 hover:shadow-2xl transition-shadow duration-300"
                >
                  {/* <Container className="cursor-pointer"> */}
                  <img
                    src={baseurl + blog.image}
                    alt="Solmelu Blog"
                    className="h-48 w-full object-cover rounded-2xl mb-4"
                  />
                  <p className="text-right mb-1 text-gray-500 text-sm">
                    {blog.createdAt ? moment(blog.createdAt).format("ll") : ""}
                  </p>
                  <Container className="font-semibold text-lg mb-2">
                    {blog.title}
                  </Container>
                  <Container className="text-sm text-gray-600 mb-4">
                    <div
                      className="prose prose-gray max-w-none"
                      dangerouslySetInnerHTML={{
                        __html:
                          blog.description.split(" ").length > 12
                            ? blog.description
                                .split(" ")
                                .slice(0, 12)
                                .join(" ") + "..."
                            : blog.description,
                      }}
                    />
                  </Container>
                  {/* </Container> */}
                  <Container className="flex justify-end gap-3">
                    <MdOutlineEdit
                      className="p-2 h-9 w-9 rounded-full cursor-pointer"
                      style={{ backgroundColor: "#ffe1a1" }}
                      onClick={() => handleUpdateModal(blog)}
                    />
                    <MdOutlineDelete
                      className="p-2 h-9 w-9 rounded-full cursor-pointer"
                      style={{ backgroundColor: "#ffe1a1" }}
                      onClick={() => handleDelete(blog)}
                    />
                  </Container>
                </Container>
              ))}
            </Container>
          ) : (
            <Container className="flex justify-center font-medium">
              <p>No results found...</p>
            </Container>
          )}
        </Container>
      ) : (
        <Container className="min-h-[65vh] flex flex-col justify-center items-center">
          <NoInternetComp />
        </Container>
      )}

      <AddBlogModal
        isModalShow={modal.addModal}
        onClose={() => setModal({ ...modal, addModal: false })}
        // handleDrop={handleDrop}
        // handleDragOver={handleDragOver}
        handleFileSelect={handleFileSelect}
        // handleRemoveImage={handleRemoveImage}
        selectedImages={selectedImages}
        fieldData={fieldData}
        setFieldData={setFieldData}
        handleSubmit={handleSubmit}
        previewUrl={previewUrl}
        videoUrl={videoUrl}
        handleUrlChange={handleUrlChange}
        videoId={videoId}
        getThumbnailUrl={getThumbnailUrl}
      />

      <AddBlogModal
        isModalShow={modal.editModal}
        onClose={() => setModal({ ...modal, editModal: false })}
        handleFileSelect={handleFileSelect}
        selectedImages={selectedImages}
        fieldData={fieldData}
        setFieldData={setFieldData}
        handleSubmit={handleSubmit}
        previewUrl={previewUrl}
        videoUrl={videoUrl}
        handleUrlChange={handleUrlChange}
        videoId={videoId}
        getThumbnailUrl={getThumbnailUrl}
      />
    </>
  );
}

export default ManageBlogView;
